<template>
  <div class="w w1200">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breakcrumbHeader">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>直播列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="live-grid" v-loading="loading">
      <div class="live-list" v-if="total">
        <div class="live-card"
             :style="{ 'backgroundImage': `url(${live.coverImg})` }"
             @click="showLiveCode(live)"
             v-for="live in liveList" :key="live.roomId">
          <div class="live-mask"></div>
          <div class="anchor">
            <i class="el-icon-user-solid"></i>
            <span class="name">{{ live.anchorName }}</span>
          </div>
          <div class="live-data">
            <div class="live-data-inner">
              <div class="live-title">{{ live.name }}</div>
              <div>
                <div class="live-state" :class="{
                'ing': live.liveStatus === 101,
                'wait': live.liveStatus === 102
              }">{{ stateMaps[live.liveStatus] }}</div>
                <span class="time" v-if="live.liveStatus === 102">{{live.startTime | formatTime('yyyy-MM-dd HH:mm:ss')}}开播</span>
              </div>
            </div>
          </div>
        </div>
        <Pagination v-bind:child-msg="{pageSize, currentPage: pageIndex, total}" @callFather="loadMore"></Pagination>
      </div>
      <empty v-else>暂无直播</empty>

      <el-dialog
        :title="liveCodeName"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <div class="code-box" v-loading="codeLoading">
          <el-image :src="qrcode" fit="contain" class="code"></el-image>
          <div class="live-name">微信扫码观看</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import {fetchLiveList, fetchLiveCode} from '../../api/xunyou';
import Pagination from "@/components/Pagination";
export default {
  name: 'liveList',
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      codeLoading: false,
      dialogVisible: false,
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      liveList: [],
      stateMaps:{
        101: '直播中',
        102: '待开始', // 待开始
        103: '已结束',
        104: '禁播',
        105: '暂停',
        106: '异常',
        107: '已过期'
      },
      qrcode: null,
      liveCodeName: null
    }
  },
  created () {
    this.search();
  },
  methods: {
    handleClose (done) {
      this.qrcode = null;
      this.liveCodeName = null;
      done();
    },
    // h5端展示直播房间码，扫码进入直播间
    showLiveCode (room) {
      this.liveCodeName = room.name;
      const params = {
        mpPath: 'pages/live/liveList',
        scene: room.roomId,
        hyalineFlag: true,
        autoColor: true
      }
      this.codeLoading = true;
      fetchLiveCode(params).then(res => {
        console.log('直播二维码：', res);
        if (res.code === 0) {
          this.qrcode = `data:image/png;base64,${res.data}`;
        }
      }).catch(err => {
        console.error('错误：', err);
      }).finally(() => {
        this.codeLoading = false;
      });
      this.dialogVisible = true;
    },
    search () {
      this.pageIndex = 0;
      this.getLiveList();
    },
    loadMore (page) {
      this.pageIndex = page.currentPage;
      this.pageSize = page.pageSize;
      this.getLiveList();
    },
    getLiveList () {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      this.loading = true
      fetchLiveList(params).then(res => {
        console.log('直播列表：', res);
        if (res.code === 0) {
          this.total = res.data.total;
          this.liveList = res.data.roomInfos.map(ele => {
            ele.startTime = ele.startTime * 1000;
            return ele;
          });
        }
      }).catch(err => {
        this.$message.error('查询失败，请稍后再试！')
      }).finally(() =>{
        this.loading = false
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.code-box{
  text-align: center;
  .code{
    width: 240px;
    height: 240px;
  }
  .live-name{
    font-size: 14px;
    color: #999;
  }
}
.live-grid{
  background-color: #fff;
  padding: 12px 6px;
}
.live-card{
  position: relative;
  display: inline-block;
  width: 282px;
  height: 282px;
  font-size: 14px;
  color: #fff;
  text-align: left;
  margin: 6px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  cursor: pointer;
  .live-mask{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.2);
    transition-duration: 0.3s;
    &:hover,&:focus{
      background: rgba(0,0,0,.1);
    }
  }
  .anchor{
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 2;
    line-height: 1;
    .el-icon-user-solid{
      width: 1em;
      height: 1em;
      border-radius: 50%;
      border: 1px solid #fff;
      vertical-align: middle;
    }
    .name{
      color: #fff;
      text-align: left;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .live-data{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100px;
    width: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.4));
  }
  .live-data-inner{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px;
    .live-title{
      font-size: 16px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 16em;
      font-weight: bold;
    }
    .live-state{
      display: inline-block;
      background-color: #999999;
      font-size: 12px;
      padding: 0 10px;
      border-radius: 8px;
      &.ing{
        background-color: var(--main-theme-color);
      }
      &.wait{
        background-color: #ffa65c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/live/liveList.vue